const cookieDomain = process.env.NEXT_PUBLIC_AUTH_COOKIE_DOMAIN;

/**
 * Parent domain of the session cookies shared with the personal account (`.nutricionlab.com`); empty means the
 * current host only (local development).
 */
export const AUTH_COOKIE_DOMAIN = cookieDomain === '' ? undefined : cookieDomain;

/** Where the session lived before the shared cookies: read once to move a signed-in user over, then removed. */
export const LEGACY_AUTH_TOKENS_STORAGE_KEY = 'auth_tokens';
